import { render, staticRenderFns } from "./setting-collect-account.vue?vue&type=template&id=642024d2&"
import script from "./setting-collect-account.vue?vue&type=script&lang=js&"
export * from "./setting-collect-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports